var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 8H0V6H6V0H8V6H14V8H8V14H6V8Z","fill":"currentColor"}));
}

Plus.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
